module.exports = "/_next/static/images/188dd31091585e44b1155fe62cb83c0b-telmex-icon.svg.webp";